import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n
} from "@/composables/useI18n";

import {
  ref,
  unref,
  watch
} from 'vue';

import {
  IssuerStatus,
} from "@/Enums";

import {
  debounce
} from "@/scripts/Common/HelperFunctions";


export default /*#__PURE__*/_defineComponent({
  __name: 'IssuerSearchFilter',
  emits: [
  'onSearchFilterChange'
],
  setup(__props, { emit: emits }) {


const {
  t,
} = useI18n();



const companyName = ref<string | undefined>();
const phoneNumber = ref<string | undefined>();
const email = ref<string | undefined>();
const contactName = ref<string | undefined>();
const selectedIssuerState = ref<IssuerStatus | undefined>();
const issuerStateItems = [
  { text: t('State.Interested'), state: IssuerStatus.Interested },
  { text: t('State.Canceled'), state: IssuerStatus.Canceled },
  { text: t('State.Confirmed'), state: IssuerStatus.Confirmed },
  { text: t('State.Contracted'), state: IssuerStatus.Contracted },
];

const onHandleChange = () => {
  emits('onSearchFilterChange', {
    issuerState: unref(selectedIssuerState),
    companyName: unref(companyName),
    phoneNumber: unref(phoneNumber),
    email: unref(email),
    contactName: unref(contactName),
  });
};

const onHandleClearCompanyName = () => {
  companyName.value = undefined;
};

const onHandleClearPhoneNumber = () => {
  phoneNumber.value = undefined;
};

const onHandleClearEmail = () => {
  email.value = undefined;
};

const onHandleClearContactName = () => {
  contactName.value = undefined;
};

const onHandleClearIssuerState = () => {
  selectedIssuerState.value = undefined;
};

watch([companyName, phoneNumber, email, contactName, selectedIssuerState], debounce(() => {
  onHandleChange();
}));


return { __sfc: true,t, emits, companyName, phoneNumber, email, contactName, selectedIssuerState, issuerStateItems, onHandleChange, onHandleClearCompanyName, onHandleClearPhoneNumber, onHandleClearEmail, onHandleClearContactName, onHandleClearIssuerState }
}

})